import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
import "./subProject.css";
// import projectLogo from "../../../public/assets/projects-logo/find-my-doc/logo.png";


function SubProject() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const projectType = params.get("project");
    console.log(projectType);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    let projectLogo = "../assets/projects-logo/find-my-doc/logo.png";
    let projectTitle = "A dynamic medical booking management platform connecting \n patients with doctors and hospitals digitally.";
    let projectDescription = "At Ambrum, we transform ambitious ideas into digital realities \nblending smart software solutions with impactful marketing to shape the future of business.";
    let projectImage = "../assets/projects-logo/find-my-doc/cover.png";
    let projectOverview = "Find My Doc (FMD) is Ambrum’s flagship doctor channeling and healthcare management application built to simplify the healthcare experience for both patients and medical professionals. This mobile-first solution empowers users to book appointments anytime, track medical history, and access digital health services on the go—bringing healthcare into the digital age. \nWhether you’re a busy urban dweller or managing care for your entire family, FMD puts control and convenience right at your fingertips.";
    let overviewImage = "../assets/projects-logo/find-my-doc/img1.png";
    let keyFeatures = [{
        title: "Doctor Booking System",
        features: "Real-time appointment booking with availability, specialization, and location filters."
    },
    {
        title: "Medical Record Tracking",
        features: "Patients can upload and access past prescriptions and medical history."
    },
    {
        title: "Family & Group Accounts",
        features: "Manage bookings and records for the entire family under one app."
    },
    {
        title: "Smart Notifications",
        features: "Automated reminders for appointments and follow-ups."
    },
    {
        title: "Doctor-Focused Portal ",
        features: "Separate app for doctors to manage their calendar, view patient records, and update schedules."
    },
    {
        title: "Location-Based Search",
        features: "Easily find nearby medical centers and specialists."
    },
    ];
    let keyFeaturesImage = "../assets/projects-logo/find-my-doc/FindMyDoc.gif";
    let subTitle1 = "Why FMD Stands Out";
    let subDescription1 = "Unlike traditional booking systems, FMD isn’t just an appointment tool. It’s a fully-integrated healthcare platform offering intelligent syncing between doctors and patients, record keeping, and patient-centered design. It’s already transforming operations for private hospitals, independent clinics, and channeling centers across Sri Lanka."
    let stack = [{ image: "../assets/projects-logo/flutter.png" }, { image: "../assets/projects-logo/node.png" }, { image: "../assets/projects-logo/google-cloud.png" }, { image: "../assets/projects-logo/react.png" }, { image: "../assets/projects-logo/python.png" }, { image: "../assets/projects-logo/firebase.png" }];
    let subTitle2 = "Why Choose Ambrum for Healthcare Tech?";
    let subDescription2 = "We understand the complexities of medical ecosystems—from compliance and security to user comfort. At Ambrum, our cross-functional team specializes in crafting digital products that combine speed, security, and simplicity. From concept to launch, we ensure the solution meets both your business goals and user expectations.";




    if (projectType === "volt-charge") {
        projectLogo = "../assets/projects-logo/volt-charge/logo.png";
        projectTitle = "VoltCharge - Powering the Future of Electric Mobility\n An intelligent EV charging ecosystem designed for convenience,\n sustainability, and scalability.";
        projectDescription = "At Ambrum, we transform ambitious ideas into digital realities \n blending smart software solutions with impactful marketing to shape the future of business.";
        projectImage = "../assets/projects-logo/volt-charge/coverImage.png";
        projectOverview = "VoltCharge is Ambrum’s end-to-end EV charging solution, developed over two years of R&D to address the growing demand for clean, accessible mobility infrastructure. The platform serves both EV users and charging providers with real-time access, data visibility, and smart station management.\nVoltCharge now powers the EV charging network used by Keells Supermarkets, enabling EV drivers to conveniently charge their vehicles across select locations while the system handles monitoring, transactions, and support behind the scenes.";
        overviewImage = "../assets/projects-logo/volt-charge/overviewimage.png";
        keyFeatures = [{
            title: "EV driver mobile app",
            features: "with charger discovery, booking, and live session tracking"
        },
        {
            title: "QR-based charging",
            features: " initiation and seamless payment handling"
        },
        {
            title: "Admin dashboard",
            features: "for real-time monitoring, maintenance, and energy analytics"
        },
        {
            title: "Future-ready architecture",
            features: "for expansion to universal charger protocols"
        },
        ];
        keyFeaturesImage = "../assets/projects-logo/volt-charge/ValtCharge.gif";
        subTitle1 = "Why VoltCharge Stands Out";
        subDescription1 = "Unlike EV systems, VoltCharge isn’t just an Electric vehicle charging tool. It’s a fully-integrated healthcare platform offering intelligent syncing between doctors and patients, record keeping, and patient-centered design. It’s already transforming operations for private hospitals, independent clinics, and channeling centers across Sri Lanka."
        stack = [{ image: "../assets/projects-logo/flutter.png" }, { image: "../assets/projects-logo/node.png" }, { image: "../assets/projects-logo/google-cloud.png" }, { image: "../assets/projects-logo/react.png" }, { image: "../assets/projects-logo/python.png" }, { image: "../assets/projects-logo/firebase.png" }];
        subTitle2 = "Why Choose Ambrum for EV Solutions?";
        subDescription2 = "Ambrum blends technical expertise, green innovation, and UX precision to deliver impactful solutions like VoltCharge. We’ve built a robust EV ecosystem with real-world deployment, live users, and proven scalability, positioning us as a regional leader in EV tech development. If you're looking to create the next big solution in clean mobility, we’re ready to drive with you.";

    }
    if (projectType === "rcgc") {
        projectLogo = "../assets/projects-logo/rcgc/logo.png";
        projectTitle = "Developed a user-friendly website for the prestigious Royal Colombo Golf Club, enhancing their online presence and member engagement.";
        projectDescription = "The RCGC mobile app, developed by Ambrum, brings the prestigious Royal Colombo Golf Club into the \ndigital age. With tee time bookings, event access, news updates, and member-focused features, the app enhances\n convenience while preserving the heritage of one of Asia’s oldest golf clubs.";
        projectImage = "../assets/projects-logo/rcgc/coverImage.png";
        projectOverview = "The Royal Colombo Golf Club (RCGC)—a historic and exclusive institution with over 140 years of legacy—sought a digital transformation to enhance member experience. Ambrum partnered with RCGC to design a mobile app that reflects its prestige while offering seamless access to core services and activities.\nThe result? A polished, user-friendly app that complements the club’s brand and tradition while bringing modern convenience to its members.";
        overviewImage = "../assets/projects-logo/rcgc/overviewimage.png";

        keyFeatures = [{
            title: "Tea Time Booking System",
            features: " with calendar view"
        },
        {
            title: "Club News & Notifications",
            features: " for real-time updates"
        },
        {
            title: "Event Listings",
            features: " with RSVP and reminders"
        },
        {
            title: "Member Profile Access ",
            features: "and account settings"
        },
        {
            title: "Modern UI/UX ",
            features: "tailored to the RCGC brand aesthetic"
        },
        ];
        keyFeaturesImage = "../assets/projects-logo/rcgc/RCGC.gif";
        subTitle1 = "Why RCGC Stands Out";
        subDescription1 = "Ambrum developed a sleek mobile application that streamlines communication between the club and its members. Built with simplicity and elegance in mind, the app empowers users to:"
        stack = [{ image: "../assets/projects-logo/flutter.png" }, { image: "../assets/projects-logo/node.png" }, { image: "../assets/projects-logo/google-cloud.png" }, { image: "../assets/projects-logo/react.png" }, { image: "../assets/projects-logo/python.png" }, { image: "../assets/projects-logo/firebase.png" }];
        subTitle2 = "Why Choose Ambrum for Club Management?";
        subDescription2 = "We understand the complexities of ecosystems—from compliance and security to user comfort. At Ambrum, our cross-functional team specializes in crafting digital products that combine speed, security, and simplicity. From concept to launch, we ensure the solution meets both your business goals and user expectations.";

    }
    if (projectType === "port-city") {
        projectLogo = "../assets/projects-logo/port-city/logo.png";
        projectTitle = "PortCity App – Your Gateway to Smart Urban Living\n A fully integrated app designed for residents, visitors, and service\nproviders within Port City Colombo.";
        projectDescription = "The PortCity App is a smart lifestyle platform designed for Sri Lanka’s most futuristic city. It connects\n residents, visitors, service providers, and city administrators through one unified system—enabling access\n to services, navigation, updates, and urban interactions like never before.";
        projectImage = "../assets/projects-logo/port-city/cover.png";
        projectOverview = "Port City Colombo is envisioned as South Asia’s most advanced urban development. To match its vision of smart, connected living, Ambrum developed the PortCity App—an integrated mobile solution built for residents, visitors, service providers, and administrators to interact with the city in real time.\nOur goal was to turn the urban space into a digital-first environment where services, access, and communication are seamlessly managed.";
        overviewImage = "../assets/projects-logo/port-city/overviewimage.png";

        keyFeatures = [{
            title: "Unified access ",
            features: "for residents, visitors, and vendors"
        },
        {
            title: "Real-time ",
            features: "city service request & response system"
        },
        {
            title: "In-app ",
            features: "navigation, booking, and information"
        },
        {
            title: "Admin portals ",
            features: "for city management and service coordination"
        },
        {
            title: "Role-based ",
            features: "user experience for maximum personalization"
        },
        ];
        keyFeaturesImage = "../assets/projects-logo/port-city/PortCity.gif";
        subTitle1 = "Why PortCity Stands Out";
        subDescription1 = "We designed a powerful, modular mobile application that acts as a digital twin of Port City’s infrastructure. It includes multiple user types and permissions, a dynamic service system, and instant access to vital city functions."
        stack = [{ image: "../assets/projects-logo/flutter.png" }, { image: "../assets/projects-logo/node.png" }, { image: "../assets/projects-logo/google-cloud.png" }, { image: "../assets/projects-logo/react.png" }, { image: "../assets/projects-logo/python.png" }, { image: "../assets/projects-logo/firebase.png" }];
        subTitle2 = "Why Choose Ambrum for Smart City Tech?";
        subDescription2 = "Ambrum is at the forefront of urban tech innovation, delivering scalable and intelligent systems for tomorrow’s cities. With deep experience in infrastructure tech, mobility solutions, and user experience design, we developed the PortCity App to be both visionary and practical—bridging people and city infrastructure through a single digital platform. We combine technical expertise, creative engineering, and domain knowledge to bring your smart city vision to life.";

    }
    if (projectType === "lets-talk") {
        projectLogo = "../assets/projects-logo/lets-talk/logo.png";
        projectTitle = "Let’s Talk – Australia’s Smart Consultation & Appointment App\n Empowering professionals and clients to connect, consult, and\n schedule with ease—anytime, anywhere.";
        projectDescription = "Let’s Talk is a sleek, powerful consultation and scheduling app built for Australian professionals. Designed to simplify client interactions, it offers appointment booking, secure messaging, calendar integration, and user-friendly admin features—all wrapped in a smooth, intuitive interface.";
        projectImage = "../assets/projects-logo/lets-talk/coverImage.png";
        projectOverview = "Let’s Talk is a modern consultation and appointment platform developed for the Australian market. Built to support professionals, therapists, consultants, coaches, and more the app makes scheduling, communication, and session tracking seamless for both service providers and clients.\nOur goal was to deliver a solution that feels simple yet powerful, helping businesses manage their appointments and relationships with just a few taps.";
        overviewImage = "../assets/projects-logo/lets-talk/overviewimage.png";
        keyFeatures = [{
            title: "A clean, modern interface ",
            features: "built for ease of use"
        },
        {
            title: "Real-time ",
            features: "availability and time slot booking."
        },
        {
            title: "Role-based ",
            features: "admin features for providers and clients"
        },
        {
            title: "In-app chat and session ",
            features: "reminders"
        },
        {
            title: "Secure cloud-based ",
            features: "data architecture"
        },
        ];
        keyFeaturesImage = "../assets/projects-logo/lets-talk/LetsTalk.gif";
        subTitle1 = "Why Let's Talk Stands Out";
        subDescription1 = "Ambrum engineered a mobile-first solution with a strong backend and highly intuitive front-end that ensures both client and provider convenience. Key design and technical elements include:"
        stack = [{ image: "../assets/projects-logo/flutter.png" }, { image: "../assets/projects-logo/node.png" }, { image: "../assets/projects-logo/google-cloud.png" }, { image: "../assets/projects-logo/react.png" }, { image: "../assets/projects-logo/python.png" }, { image: "../assets/projects-logo/firebase.png" }];
        subTitle2 = "Why Choose Ambrum for Custom Mobile Solutions?";
        subDescription2 = "We don’t just build apps—we build scalable, purpose-driven digital platforms that empower users. With Let’s Talk, we applied our expertise in healthcare, scheduling systems, and user-centric design to create a truly market-ready solution. Whether you're in Australia or anywhere in the world, Ambrum brings together strategic thinking, advanced development, and brand-aligned design to deliver mobile apps that convert and retain users.";

    }

    return (
        <div>
            <Container className="mt-9">
                <img
                    src={projectLogo}
                    className="col-12 col-md-2 my-4 project-logo "
                    alt=""
                />
                <h4 className="project-header" >
                    {projectTitle}
                </h4>
                <p className="projectDescription mt-4">
                    {projectDescription.split('\n').map((line, index) => (
                        <span key={index}>
                            {line}
                            <br />
                        </span>
                    ))}
                </p>
                <img
                    src={projectImage}
                    className="w-100"
                    alt=""
                />
                <div className="row m-4 justify-content-center">
                    <p className="text-start">Project Overview</p>
                    <div className="col-lg-7 col-md-6 col-sm-12 col-12">
                        <p className="text-justify ovrViewText">
                            {projectOverview.split('\n').map((line, index) => (
                                <span key={index}>
                                    {line}
                                    <br />
                                </span>
                            ))}
                        </p>
                    </div>
                    <div className="col-lg-5 col-md-5 col-sm-12 col-12">
                        <img
                            src={overviewImage}
                            className="w-100"
                            alt=""
                        />
                    </div>
                </div>
                <div className="row m-4 justify-content-center">
                    <p className="text-start">Key Features We Engineered</p>
                    <div className="col-lg-5 col-md-5 col-sm-12 col-12">
                        <img
                            src={keyFeaturesImage}
                            className="w-100"
                            alt=""
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <ul className="text-justify">
                            {keyFeatures.map((feature, index) => (
                                <li key={index} className=" key-text">
                                    <b className="key_title">{feature.title}</b> - {feature.features}{" "}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div>
                    <p className="text-start text-center">{subTitle1}</p>
                    <p className=" key-text text-center">
                        {subDescription1}
                    </p>
                </div>
                <div className="m-5">
                    <p className="text-start text-center">Tech Stack & Integration</p>
                    <div className="row justify-content-around">
                        {stack.map((item, index) => (
                            <div
                                className={`col-4 col-sm-3 col-md-${index === 1 ? '2' : '1'} col-lg-${index === 1 ? '2' : '1'}`}
                                key={index}
                            >
                                <img
                                    src={item.image}
                                    className="img-fluid mx-3 mt-5"  // Better than w-100 for responsive images
                                    alt={item.name || "technology icon"}  // Always good to have proper alt text
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    <p className="text-start text-center">{subTitle2}</p>
                    <p className=" key-text text-center">
                        {subDescription2}
                    </p>
                </div>
                {/* <div className="container text-center">
          <div className="hero-text fw-700 my-5">
            LET’S{" "}
            <span className="hero-text-gradient">TRANSFORM THE FUTURE</span>{" "}
            <br />
            TOGETHER
          </div>
          <p>Book a free consultation{">"}</p>
        </div> */}
            </Container>

            <ContactUsFooter />
            <br />
            <Footer />
        </div>
    );
}

export default SubProject;
